import {FC} from 'react'
import queryString from 'query-string'
import {useLocation} from 'react-router-dom'
import {ADD_DEPENDENTS} from 'consts/procedureType'
import {RequireEmployeeUpdateRouter} from 'components/router/RequireEmployeeUpdateRouter'
import {Container, StartProcedureCard} from 'features/procedures/StartProcedureCard'
import style from './ChooseNewOrExists.scss'
import {useSelector} from 'hooks/redux'
import {isAdminSelector} from 'libs/redux'

const ChooseNewOrExists: FC = () => {
  const {search, pathname} = useLocation()
  const {isAdmin, currentUserEmployeeId} = useSelector((state) => ({
    isAdmin: isAdminSelector(state),
    currentUserEmployeeId: state.session.currentUser.employee?.id,
  }))
  const isEmployeeInput = !isAdmin || pathname.includes('/mypage/')
  const employeeId = isEmployeeInput ? currentUserEmployeeId : queryString.parse(search)['employee_id']

  const redirectPath = isEmployeeInput
    ? `/dashboard?error=employee_info`
    : `/employees/${employeeId}/edit?procedure_type=${ADD_DEPENDENTS}&next_action=choose_new_or_exists`

  return (
    <RequireEmployeeUpdateRouter employeeId={employeeId as string} redirectPath={redirectPath}>
      <div className="l-title-wrap">
        <h1 className="m-title-main">変更方法を選択</h1>
      </div>
      <Container>
        <StartProcedureCard
          to={
            isEmployeeInput
              ? '/mypage/add_dependents/employee_input'
              : `/add_dependents/detail?employee_id=${employeeId}`
          }
          variant="start"
        >
          <span className={style.buttonText}>新たな家族を登録する</span>
        </StartProcedureCard>
        <StartProcedureCard
          to={
            isEmployeeInput
              ? '/mypage/add_dependents/choose_exist_dependents'
              : `/add_dependents/choose_exist_dependents?employee_id=${employeeId}`
          }
          variant="start"
        >
          <span className={style.buttonText}>既存の家族情報を利用する</span>
        </StartProcedureCard>
      </Container>
    </RequireEmployeeUpdateRouter>
  )
}

export default ChooseNewOrExists
